import {defineSlotRecipe} from '@chakra-ui/react3'

export const collageRecipe = defineSlotRecipe({
    slots: [
        'moduleContainer',
        'textBox',
        'gridContainer',
        'grid',
        'topLeft',
        'topLeftBox',
        'topRight',
        'topRightBox',
        'imageBox',
        'leftCenter',
        'leftCenterBox',
        'bottomLeft',
        'bottomLeftBox',
        'centerCenter',
        'centerCenterBox',
        'bottomCenter',
        'bottomCenterBox',
        'centerRight',
        'centerRightBox',
        'bottomRight',
        'bottomRightBox',
        'leftColumn',
        'rightColumn'
    ],
    base: {
        moduleContainer: {
            overflow: 'hidden',
            position: 'relative',
            paddingTop: {base: 'spacing-64', s: 'spacing-128'},
            paddingBottom: {base: 'spacing-40', s: 'spacing-128'}
        },
        textBox: {
            width: {base: '100%', s: '38.8rem'},
            paddingX: {base: 'spacing-24', s: 'spacing-80'},
            position: 'absolute',
            left: '50%',
            transform: 'translate(-50%, calc(-50% - 24px))',
            top: '50%',
            opacity: 0,
            transition:
                'opacity 0.7s cubic-bezier(0, 0, 0, 1) 1.5s, transform 0.7s cubic-bezier(0, 0, 0, 1) 1.5s'
        },
        imageBox: {
            borderRadius: 'lg',
            overflow: 'hidden'
        },
        topLeft: {
            gridColumnStart: 1,
            gridColumnEnd: 4,
            gridRowStart: 1,
            justifySelf: 'end',
            transition: 'transform 1.5s cubic-bezier(0.8, 0, 0.2, 1)',
            transform: 'translate(0, 0)'
        },
        topLeftBox: {
            aspectRatio: 3 / 4,
            width: {base: '5.0625rem', xs: '9.5rem', s: '14.8125rem'}
        },
        topRight: {
            gridColumnStart: 4,
            gridRowStart: 1,
            alignSelf: 'end',
            transition: 'transform 1.5s cubic-bezier(0.8, 0, 0.2, 1)',
            transform: 'translate(0, 0)'
        },
        topRightBox: {
            aspectRatio: 16 / 10,
            width: {base: '9.25rem', xs: '17.4375rem', s: '27rem'}
        },
        leftCenter: {
            transition: 'transform 1.5s cubic-bezier(0.8, 0, 0.2, 1)',
            transform: 'translate(0, 0)'
        },
        bottomLeft: {
            transition: 'transform 1.5s cubic-bezier(0.8, 0, 0.2, 1)',
            transform: 'translate(0, 0)'
        },
        centerCenter: {
            transition: 'transform 2s cubic-bezier(0.8, 0, 0.2, 1)',
            transform: 'translate(0, 0)',
            aspectRatio: 3 / 4,
            width: {base: '6.4375rem', xs: '12rem', s: '18.875rem'}
        },
        bottomCenter: {
            transition: 'transform 1.5s cubic-bezier(0.8, 0, 0.2, 1)',
            transform: 'translate(0, 0)'
        },
        centerRight: {
            transition: 'transform 1.5s cubic-bezier(0.8, 0, 0.2, 1)',
            transform: 'translate(0, 0)'
        },
        bottomRight: {
            transition: 'transform 1.5s cubic-bezier(0.8, 0, 0.2, 1)',
            transform: 'translate(0, 0)'
        },
        gridContainer: {
            py: 8,
            display: 'flex',
            justifyContent: 'center'
        },
        grid: {
            templateColumns: 'repeat(8, auto)',
            gap: 4,
            marginX: 'auto',
            width: 'fit-content',
            maxWidth: '100vw'
        },
        leftCenterBox: {
            aspectRatio: 16 / 10,
            width: {base: '8.75rem', xs: '16.5rem', s: '25.625rem'}
        },
        bottomLeftBox: {
            aspectRatio: 1,
            width: {base: '5.75rem', xs: '10.75rem', s: '16.875rem'}
        },
        centerCenterBox: {
            aspectRatio: 3 / 4,
            width: {base: '6.4375rem', xs: '12rem', s: '18.875rem'}
        },
        bottomCenterBox: {
            aspectRatio: 4 / 3,
            width: {base: '6.4375rem', xs: '12.0625rem', s: '18.875rem'}
        },
        centerRightBox: {
            aspectRatio: 1,
            width: {base: '6.25rem', xs: '11.5rem', s: '18.0625rem'}
        },
        bottomRightBox: {
            aspectRatio: 1,
            width: {base: '5rem', xs: '9.375rem', s: '14.5rem'}
        },
        leftColumn: {
            gridColumnStart: 1,
            gridColumnEnd: 4,
            gridRowStart: 2,
            justifySelf: 'end',
            flexDirection: 'column',
            gap: 4,
            alignItems: 'end'
        },
        rightColumn: {
            gridColumnStart: 4,
            gridRowStart: 2,
            gap: 4,
            alignItems: 'start'
        }
    },
    variants: {
        isVisible: {
            true: {
                topLeft: {
                    transform: {
                        base: 'translate(-20vw, 0)',
                        xs: 'translate(-23vw, 0)',
                        s: 'translate(-9.375rem, -12.5rem)'
                    }
                },
                topRight: {
                    transform: {
                        base: 'translate(39vw, -5rem)',
                        s: 'translate(25rem, -12.5rem)'
                    }
                },
                leftCenter: {
                    transform: {
                        base: 'translate(-25vw, 20rem)',
                        xs: 'translate(-20vw, 20rem)',
                        s: 'translate(-10.938rem, 0)'
                    }
                },
                bottomLeft: {
                    transform: {
                        base: 'translate(0, 22rem)',
                        xs: 'translate(0, 25rem)',
                        s: 'translate(-9.375rem, 9.375rem)'
                    }
                },
                centerCenter: {
                    transform: {
                        base: 'translate(-10vw, -17rem)',
                        xs: 'translate(-10vw, -25rem)',
                        s: 'translate(-3.125rem, -34.375rem)'
                    }
                },
                bottomCenter: {
                    transform: {
                        base: 'translate(20vw, 22rem)',
                        xs: 'translate(17vw, 20rem)',
                        s: 'translate(0, 9.375rem)'
                    }
                },
                centerRight: {
                    transform: {
                        base: 'translate(20vw, -3rem)',
                        s: 'translate(9.375rem, 0)'
                    }
                },
                bottomRight: {
                    transform: {
                        base: 'translate(10vw, 15rem)',
                        xs: 'translate(15vw, 10rem)',
                        s: 'translate(6.25rem, 9.375rem)'
                    }
                },
                textBox: {
                    opacity: 1
                }
            }
        }
    }
})
